import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Sidebar = ({ userType, menuConfig, isOpen, onClose, currentPath }) => {
  const [expandedItems, setExpandedItems] = useState({});

  useEffect(() => {
    const autoExpandMenus = () => {
      const newExpandedItems = {};
      const userMenu = menuConfig[userType];
      userMenu?.items?.forEach((item) => {
        if (item.submenu) {
          const shouldExpand = item.submenu.some(subItem =>
            currentPath === subItem.link || currentPath.startsWith(subItem.link)
          );
          if (shouldExpand) newExpandedItems[item.id] = true;
        }
      });
      setExpandedItems(newExpandedItems);
    };

    if (menuConfig[userType]) autoExpandMenus();
  }, [currentPath, userType, menuConfig]);

  const toggleSubmenu = (itemId) => {
    setExpandedItems(prev => ({ ...prev, [itemId]: !prev[itemId] }));
  };

  const isItemActive = (item) => {
    if (item.link && (currentPath === item.link || currentPath.startsWith(item.link))) return true;
    if (item.submenu) return item.submenu.some(sub => currentPath === sub.link || currentPath.startsWith(sub.link));
    return false;
  };

  if (!menuConfig[userType]) return null;
  const userMenu = menuConfig[userType];

  return (
    <aside
      className={`fixed md:relative top-0 right-0 h-full z-40 transition-all duration-300 ease-in-out bg-white border-l border-gray-200 shadow-lg md:shadow-none
      ${isOpen ? 'w-full md:w-64 translate-x-0' : 'w-0 -translate-x-full md:translate-x-0 overflow-hidden'}`}
    >
      {/* هدر سایدبار - فقط در موبایل برای بستن */}
      <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-gray-50/50">
        <h2 className="text-sm font-bold text-[#1E3A5F]">{userMenu.title}</h2>
        <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-200 text-gray-500 md:hidden">
          <FaTimes size={20} />
        </button>
      </div>

      <nav className="p-3 space-y-1 overflow-y-auto h-[calc(100vh-70px)]">
        {userMenu.items.map((item) => {
          const isActive = isItemActive(item);
          const isExpanded = expandedItems[item.id];

          return (
            <div key={item.id} className="space-y-1">
              <div
                className={`flex items-center justify-between px-4 py-3 rounded-lg cursor-pointer transition-all
                  ${isActive
                    ? 'bg-[#1E3A5F] text-[#FFC107]'
                    : 'text-gray-700 hover:bg-gray-100 hover:text-[#1E3A5F]'}`}
                onClick={() => item.submenu ? toggleSubmenu(item.id) : null}
              >
                {item.link && !item.submenu ? (
                  <Link to={item.link} className="flex-1 text-sm font-medium">{item.label}</Link>
                ) : (
                  <span className="text-sm font-medium">{item.label}</span>
                )}

                {item.submenu && (
                  <FaChevronLeft className={`text-[10px] transition-transform duration-200 ${isExpanded ? '-rotate-90' : ''}`} />
                )}
              </div>

              {item.submenu && isExpanded && (
                <div className="pr-4 space-y-1 mt-1">
                  {item.submenu.map((subItem) => (
                    <Link
                      key={subItem.id}
                      to={subItem.link}
                      className={`block py-2.5 px-4 rounded-lg text-xs transition-all
                        ${currentPath === subItem.link
                          ? 'bg-[#00AFA9] text-white font-bold'
                          : 'text-gray-600 hover:bg-gray-50 hover:text-[#1E3A5F]'}`}
                    >
                      • {subItem.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;
